import React from "react";
import { Tooltip } from "primereact/tooltip";
import { useTranslation } from 'react-i18next';
const ExportToCsv = ({ jsonData, filename }) => {
  const exportToCsv = () => {
    const csvData = convertToCsv(jsonData);
    const blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });

    if (navigator.msSaveBlob) {
      // IE 10+
      navigator.msSaveBlob(blob, filename);
    } else {
      const link = document.createElement("a");
      if (link.download !== undefined) {
        // Feature detection
        const url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", filename);
        link.style.visibility = "hidden";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
  };
  const {t}=useTranslation();
 const EXCEL_DOWNLOAD=t("EXCEL_DOWNLOAD")

  const convertToCsv = (data) => {
    const csvRows = [];
    const columns = Object.keys(data[0]);

    // Add column headers
    csvRows.push(columns.join(","));

    // Add data rows
    for (const row of data) {
      const values = columns.map((column) => row[column]);
      const escapedValues = values.map((value) => `"${value}"`);
      csvRows.push(escapedValues.join(","));
    }

    return csvRows.join("\n");
  };

  return (
    <>
      <Tooltip target=".journey-table-excel-tip" />
      <i
        className="cursor-pointer pi pi-file-excel journey-table-excel-tip"
        data-pr-tooltip={EXCEL_DOWNLOAD}
        data-pr-position="left"
        onClick={() => exportToCsv()}
      />
    </>
  );
};

export default ExportToCsv;
